import { withInstall } from '@zoryn/utils'
import Upload from './src/upload.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZUpload: SFCWithInstall<typeof Upload> = withInstall(Upload)
export default ZUpload

export * from './src/upload'
export * from './src/upload-content'
export * from './src/upload-list'
export * from './src/upload-dragger'
export * from './src/constants'
export { ajaxUpload } from './src/ajax'
